import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Topic from '@/store/entities/articles/topic'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations'

interface TopicState extends ListState<Topic>{
    editTopic: Topic
}

class TopicModule extends ListModule<TopicState,any,Topic> {
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Topic>(),
        loading:false,
        editTopic:new Topic()
    };
    actions = {
        async getAll(context:ActionContext<TopicState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Topic/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Topic>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<TopicState,any>,payload:any){
            await Ajax.post('/api/services/app/Topic/Create',payload.data);
        },
        async update(context:ActionContext<TopicState,any>,payload:any){
            await Ajax.put('/api/services/app/Topic/Update',payload.data);
        },
        async delete(context:ActionContext<TopicState,any>,payload:any){
            await Ajax.delete('/api/services/app/Topic/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<TopicState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Topic/Get?Id='+payload.id);
            return reponse.data.result as Topic;
        }
    };
    mutations={
        setCurrentPage(state:TopicState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:TopicState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:TopicState,topic:Topic){
            state.editTopic=topic;
        }
    }
}

const topicModule = new TopicModule();
export default topicModule;